module.exports = __webpack_public_path__ + "img/contribute.9c1772c3.svg";